import { HowToWorkPage } from "../HowToWorkPage"
import { ownerConfig } from "../configs/owner.config"

export function HowToWorkOwner() {
    return <HowToWorkPage config={ownerConfig} />
}
